var map = {
	"./AVAX.png": "1bd4",
	"./FTM.png": "86e2",
	"./Frame659.png": "0994",
	"./USDC.png": "ea5f",
	"./bondimg.png": "5428",
	"./error.png": "29c9",
	"./layerZero.png": "8eae",
	"./polygon.png": "2645",
	"./testAVAX.png": "9eef",
	"./testETH.png": "3010",
	"./testFTM.png": "b8df",
	"./testMATIC.png": "27d2",
	"./testUSDC.png": "61fc",
	"./yes.png": "b3a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b917";